import {Injectable,} from '@angular/core';
import {SettingsService} from 'app/original-services/settings.service';
import {LoggerService} from 'app/original-services/logger.service';

declare let tap: any;

@Injectable({ providedIn: 'root' })
export class FirstPromoterService {
    isEnabled: boolean;

    constructor(private settings: SettingsService,
                private logger: LoggerService) {
        this.isEnabled = settings.promoterEnabled;
    }

    trackPage(customerId: string) {
        let logger = this.logger;
        try {
            if (this.isEnabled) {
                if (!window['fpr']) {
                    logger.error('First Promoter not intialized correctly, customerId ' + customerId);

                } else {
                    window['fpr']('referral', {uid: customerId});
                    logger.log('First Promoter track signup for ' + customerId);
                }
            }
        } catch (err) {
            logger.error(err);
            logger.error('First Promoter track signup error for ' + customerId);
        }
    }
}
